/**
 * Object of digital skus
 */

export default {
  HD_SCAN: 'hdscan',
  HD_SCAN_ROLL: 'hdscanroll',
  TIFF_SCAN: 'tiffscan'
};
